import { RouteVariables } from 'types/routes'

export const ROUTES = {
  ABOUT: {
    nl: 'onze-missie',
    fr: 'notre-mission'
  },
  ANCIENNE_BELGIQUE: {
    nl: 'ancienne-belgique',
    fr: 'ancienne-belgique'
  },
  BECOME_PRODUCER: {
    nl: 'opwekker-worden',
    fr: 'devenir-producteur'
  },
  BECOME_PRODUCER_REQUEST: {
    nl: 'opwekker-worden/aanvraag',
    fr: 'devenir-producteur/application'
  },
  BLOG: {
    nl: 'nieuws',
    fr: 'actus'
  },
  BLOG_ARTICLE: {
    nl: `nieuws/${RouteVariables.ARTICLE}`,
    fr: `actus/${RouteVariables.ARTICLE}`
  },
  BOLT_FIX: {
    nl: 'bolt-vast',
    fr: 'bolt-fixe'
  },
  BOLT_FIX_OPT_IN: {
    nl: 'overstappen-naar-bolt-vast',
    fr: 'passer-a-bolt-fixe'
  },
  BRUSSELS_AIRPORT: {
    nl: 'brussels-airport',
    fr: 'brussels-airport'
  },
  CAREERS: {
    nl: 'vacatures',
    fr: 'jobs'
  },
  CAREER_DETAIL: {
    nl: `vacatures/${RouteVariables.SLUG}`,
    fr: `jobs/${RouteVariables.SLUG}`
  },
  COMPLAINT: {
    nl: 'klacht',
    fr: 'plainte'
  },
  DYNAMIC_PRICES: {
    nl: 'dynamische-prijzen',
    fr: 'prix-dynamiques'
  },
  ENCYCLOPEDIA: {
    nl: 'encyclopedie',
    fr: 'encyclopedie'
  },
  ENCYCLOPEDIA_ARTICLE: {
    nl: `encyclopedie/${RouteVariables.CATEGORY}/${RouteVariables.SUB_CATEGORY}/${RouteVariables.ARTICLE}`
    // fr: `encyclopedie/${RouteVariables.CATEGORY}/${RouteVariables.SUB_CATEGORY}/${RouteVariables.ARTICLE}`
  },
  ENCYCLOPEDIA_CATEGORY: {
    nl: `encyclopedie/${RouteVariables.CATEGORY}`
    // fr: `encyclopedie/${RouteVariables.CATEGORY}`
  },
  ENCYCLOPEDIA_SUB_CATEGORY: {
    nl: `encyclopedie/${RouteVariables.CATEGORY}/${RouteVariables.SUB_CATEGORY}`
    // fr: `encyclopedie/${RouteVariables.CATEGORY}/${RouteVariables.SUB_CATEGORY}`
  },
  ENERGY_CRISIS_FAQ: {
    nl: 'energie-begrijpen',
    fr: 'comprendre-l-energie'
  },
  REGISTRATION_LOADING: {
    nl: 'stap-over',
    fr: 'enregistrer-maintenant'
  },
  FAQ: {
    nl: 'help',
    fr: 'aide'
  },
  FESTIVALS: {
    nl: 'festivals',
    fr: 'festivals'
  },
  INJECTION_TARIFF: {
    nl: 'injectietarief',
    fr: 'tarif-d-injection'
  },
  MOVE: {
    nl: 'verhuizen',
    fr: 'demenager'
  },
  MOVE_LP: {
    nl: 'schone-start-schone-stroom',
    fr: 'repartez-bon-pied-avec-electricite-d-a-cote'
  },
  PERSONALIZED_OFFER: {
    nl: 'onze-producenten/jouw-persoonlijk-aanbod',
    fr: 'nos-producteurs/votre-offre-personnelle'
  },
  PRICELISTS: {
    nl: 'prijslijsten',
    fr: 'listes-des-prix'
  },
  PRICING: {
    nl: 'tarief',
    fr: 'tarif'
  },
  PRIVACY: {
    nl: 'disclaimer-privacy-policy',
    fr: 'mentions-legales-politique-de-confidentialite'
  },
  PRODUCERS: {
    nl: 'onze-producenten',
    fr: 'nos-producteurs'
  },
  PRODUCER_INFO: {
    nl: `onze-producenten/${RouteVariables.SLUG}`,
    fr: `nos-producteurs/${RouteVariables.SLUG}`
  },
  PROJECTS: {
    nl: 'projecten',
    fr: 'projets'
  },
  PROJECT_DETAIL: {
    nl: `projecten/${RouteVariables.SLUG}`,
    fr: `projets/${RouteVariables.SLUG}`
  },
  REFERRAL: {
    nl: 'overtuig-een-vriend',
    fr: 'convaincre-un-ami'
  },
  REGISTRATION: {
    nl: `onze-producenten/${RouteVariables.SLUG}/bestel`,
    fr: `nos-producteurs/${RouteVariables.SLUG}/ordre`
  },
  SETTLEMENT: {
    nl: 'afrekening',
    fr: 'regularisation'
  },
  SIMULATION: {
    nl: 'persoonlijk-voorstel',
    fr: 'proposition-personnelle'
  },
  SPRING_CAMPAIGN: {
    nl: 'weetvanwaarjestroomkomt'
    // fr: ''
  },
  TERMS_AND_CONDITIONS: {
    nl: 'algemene-voorwaarden',
    fr: 'termes-et-conditions'
  },
  OLD_TERMS_AND_CONDITIONS: {
    nl: `algemene-voorwaarden/${RouteVariables.VERSION}`,
    fr: `termes-et-conditions/${RouteVariables.VERSION}`
  }
}

// Routes used to generate sitemap
export const STATIC_ROUTES = [
  {
    nl: 'onze-producenten',
    fr: 'nos-producteurs'
  },
  {
    nl: 'nieuws',
    fr: 'actus'
  },
  {
    nl: 'onze-missie',
    fr: 'notre-mission'
  },
  {
    nl: 'prijzen',
    fr: 'prix'
  },
  {
    nl: 'help',
    fr: 'aide'
  },
  {
    nl: 'vacatures',
    fr: 'jobs'
  },
  {
    nl: 'overtuig-een-vriend',
    fr: 'convaincre-un-ami'
  },
  {
    nl: 'projecten',
    fr: 'projets'
  },
  {
    nl: 'projecten/camping-belgica',
    fr: 'projets/camping-belgica'
  },
  {
    nl: 'projecten/rockwerchter2022'
    // fr: 'projets/rockwerchter2022' // not available in FR
  },
  {
    nl: 'projecten/brussels-beer-project',
    fr: 'projets/brussels-beer-project'
  },
  {
    nl: 'projecten/stop-sjoemelstroom-ijsland',
    fr: 'projets/energievertdegris-islande'
  },
  {
    nl: 'projecten/de-wei-dieselvrij',
    fr: 'projets/les-festivals-sans-diesel'
  },
  {
    nl: 'prijslijsten',
    fr: 'listes-des-prix'
  },
  {
    nl: 'afrekening',
    fr: 'regularisation'
  },
  {
    nl: 'algemene-voorwaarden',
    fr: 'termes-et-conditions'
  },
  {
    nl: 'disclaimer-privacy-policy',
    fr: 'mentions-legales-politique-de-confidentialite'
  },
  {
    nl: 'verhuizen',
    fr: 'demenager'
  },
  {
    nl: 'stap-over',
    fr: 'enregistrer-maintenant'
  },
  {
    nl: 'injectietarief',
    fr: 'tarif-d-injection'
  }
]
